export default __webpack_public_path__ + "static/conf-2019-c1a94843337116744aa0030df6aa68be.png";